// @ts-check
/** @typedef {import('../types/api').Customer} Customer */
/** @typedef {import('../types/api').PaginatedCustomers} PaginatedCustomers */
/** @typedef {import('../types/api').CustomerDetail} CustomerDetail */
/** @typedef {import('../types/api').CustomersSummary} CustomersSummary */

import api from '../utils/apiClient';
import { assertShape } from '../utils/apiGuards';

const adminCustomerService = {
  /**
   * @param {Object} [params]
   * @returns {Promise<PaginatedCustomers>}
   */
  getCustomers: async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    const qs = queryParams.toString();
    const data = await api.get(`/api/admin/customers/${qs ? `?${qs}` : ''}`);
    assertShape(data, ['items', 'total'], 'adminCustomerService.getCustomers');
    return data;
  },

  /**
   * @param {string} customerId
   * @returns {Promise<CustomerDetail>}
   */
  getCustomerDetail: async (customerId) => {
    const data = await api.get(`/api/admin/customers/${customerId}`);
    assertShape(data, ['id'], 'adminCustomerService.getCustomerDetail');
    return data;
  },

  /**
   * @returns {Promise<CustomersSummary>}
   */
  getCustomersSummary: async () => {
    const data = await api.get('/api/admin/customers/stats/summary');
    assertShape(data, ['total_customers'], 'adminCustomerService.getCustomersSummary');
    return data;
  },
};

export default adminCustomerService;
